"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CompanyMyApprovalsCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const UserContext_1 = require("../contexts/UserContext");
const react_native_1 = require("react-native");
const cancelable_promise_1 = require("cancelable-promise");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Loading_1 = __importDefault(require("../components/Loading"));
const Button_1 = __importDefault(require("../components/Button"));
const react_i18next_1 = require("react-i18next");
const TimeAttendance_1 = __importDefault(require("../api/TimeAttendance"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
function CompanyMyApprovalsCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [summary, setSummary] = react_1.default.useState({});
    const refresh = react_1.default.useCallback(async () => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => {
            TimeAttendance_1.default.getApprovals(token).then((data) => {
                let grouped = {};
                data?.list?.reduce((g, v) => {
                    if (v.type in g)
                        g[v.type].count += 1;
                    else
                        g[v.type] = { type: v.type, count: 1 };
                    return g;
                }, grouped);
                setSummary(grouped);
                setStatus('done');
            });
        }).catch((e) => {
            setSummary({});
            setStatus(e == 404 ? 'done' : 'error');
        }));
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => { promise.current?.cancel(); };
    }, []);
    return ((0, jsx_runtime_1.jsx)(Card_1.default, { style: { padding: 0 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { style: { padding: 12 }, onPress: () => props.navigation.navigate('CompanyApprovals'), children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('company:labels.myApprovals'), style: { marginBottom: 8 }, children: (0, jsx_runtime_1.jsxs)(Button_1.default, { type: 'outline', color: THEME.Primary, onPress: () => props.navigation.navigate('CompanyApprovals'), children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontSize: 14, fontWeight: '500', marginHorizontal: 6 }, children: t('common:text.viewAll') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.ChevronRight, size: 14, style: { marginRight: 6 } })] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator, { marginVertical: 4, marginHorizontal: -12 }] }), status == 'done'
                    &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 10, marginBottom: 2 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'column', justifyContent: 'space-evenly', gap: 8 }, children: Object.values(summary).length == 0
                                    &&
                                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginVertical: 4, gap: 12, alignItems: "center", justifyContent: "center" }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.CalendarCheck, size: 48, color: THEME.ImageNull }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { textAlign: 'center', fontSize: 16, color: THEME.TextNull }, children: t('company:text.nothingAssignedToMe') })] })
                                    ||
                                        Object.values(summary).map((item) => (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                gap: 12,
                                                padding: 8,
                                                opacity: (item.count > 0 ? 1 : 0.5),
                                            }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                                        backgroundColor: THEME.Butter,
                                                        borderRadius: 4,
                                                        paddingVertical: 4, paddingHorizontal: 16,
                                                        flexDirection: 'row', gap: 4, alignItems: 'center'
                                                    }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                            color: THEME.WarningText,
                                                            fontSize: 24, fontWeight: '500'
                                                        }, children: item.count }) }), (0, jsx_runtime_1.jsxs)(react_native_1.Text, { numberOfLines: 1, style: {
                                                        flex: 1, color: THEME.Text, fontSize: 16
                                                    }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: 16, fontWeight: '500' }, children: (() => {
                                                                switch (item.type) {
                                                                    case 'LR': return 'Leave Requests';
                                                                    case 'I9': return 'I-9 Section 2s';
                                                                }
                                                            })() }), " ", (0, jsx_runtime_1.jsx)(react_native_1.Text, { children: t('company:text.assignedToMe') })] })] }, item.type)) }) })
                    ||
                        (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() })] }) }));
}
